var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header main-clear"},[_c('router-link',{staticClass:"header-logo",attrs:{"to":{name: 'Home'}}},[_vm._v("ис-Нейва")]),_vm._v(" "),_c('UserMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }